
import React from "react";
import { Button } from "@mui/material";
import { IconButton } from "@material-ui/core";
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

export function HubCard(props) {
    const {
        activeCard, 
        cardID, 
        cardImg, 
        cardTitle, 
        cardText, 
        cardVideo, 
        cardVideoTutorial,
        cardLink, 
        desktop, 
        handleActiveCard, 
        handleDeactiveCard, 
        ShowInfoDialog } = props;

    return (
        <>
            {cardText =="" ? (
                <Link className="sig_Hub_Card_Link" to={cardLink}>
                    <div className={`sig_Hub_Card ${activeCard === cardID ? 'sig_Hub_CardActive' : ''}`} onClick={() => handleActiveCard(cardID)}>
                        <div className="sig_Hub_CardImg">              
                            <img className={'sig_Hub_Img_Main'} src={cardImg} alt={'Búsqueda en LSE'}/> 
                        </div>
                        <div className="sig_Hub_CardInfoContainer">
                            <div className="sig_Hub_CardTitle">
                                <h2>{cardTitle}</h2>
                            </div>
                        </div>
                    </div>
                </Link>
            ) : (
                <div className={`sig_Hub_Card ${activeCard === cardID ? 'sig_Hub_CardActive' : ''}`} onClick={() => handleActiveCard(cardID)}>
                    <div className="sig_Hub_CardImg">              
                        <img className={'sig_Hub_Img_Main'} src={cardImg} alt={'Búsqueda en LSE'}/> 
                    </div>
                    <div className="sig_Hub_CardInfoContainer">
                        <Link className="sig_Hub_Card_Link" to={cardLink}>
                            <div className="sig_Hub_CardTitle">
                                <h2>{cardTitle}</h2>
                            </div>
                        </Link>
                        <Button className="sig_Hub_Card_Button" onClick={() => ShowInfoDialog(cardTitle, cardText, cardVideo, cardVideoTutorial, cardLink)}>
                            + INFO
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
}